import React, { createContext, useContext, useState, PropsWithChildren } from 'react';
import { companyList } from '../../pages/CompanyProfilePage/modal';

// Define the interface for context values
interface CompanyProfileContextType {
    
    selectedCompany: companyList | null;
    setSelectedCompany: React.Dispatch<React.SetStateAction<companyList | null>>;
    refreshTable: boolean;
    setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
    isListLoading: boolean;
    setIsListLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create context with initial values
const CompanyProfileContext = createContext<CompanyProfileContextType | undefined>(undefined);

// Create a provider component to wrap your app
export const CompanyProfileProvider = ({ children }: PropsWithChildren<{}>) => {
    const [selectedCompany, setSelectedCompany] = useState<companyList | null>(null);
    const [refreshTable, setRefreshTable] = useState(false)
    const [isListLoading, setIsListLoading] = useState(true)

    return (
        <CompanyProfileContext.Provider value={{
            selectedCompany, setSelectedCompany,
            refreshTable, setRefreshTable,
            isListLoading, setIsListLoading
        }}>
            {children}
        </CompanyProfileContext.Provider>
    );
};

// Create a custom hook for using CompanyProfileContext
export const useCompanyProfileContext = () => {
    const context = useContext(CompanyProfileContext);
    if (!context) {
        throw new Error('useCompanyProfileContext must be used within a CompanyProfileProvider');
    }
    return context;
};

export default CompanyProfileContext;
